import React from 'react'
import { Route, Redirect, } from 'react-router-dom'
import jwt_decode from "jwt-decode";
import Sample from './../components/Sample/sample';
import ExtLogin from './../components/ExtLogin/ExtLogin'
import Dashboard from '../components/DashBoard/dashboard';

const roles = (process.env.REACT_APP_ROLES || 'Admin,User,Manager').split(',');

// Development mode: Create a fake token if none exists
if (process.env.NODE_ENV === 'development' && !localStorage.getItem("auth_token")) {
    // Create a fake JWT token for development with all required fields
    const fakePayload = {
        roles: ["Admin"],
        name: "Dev User",
        email: "dev@localhost.com",
        unique_name: "dev@localhost.com", // Required by backend views
        exp: 9999999999,
        iat: Math.floor(Date.now() / 1000)
    };
    const fakeParts = [
        'eyJhbGciOiJub25lIiwidHlwIjoiSldUIn0', // header
        btoa(JSON.stringify(fakePayload)), // payload
        '' // signature
    ];
    localStorage.setItem("auth_token", fakeParts.join('.'));
    console.log('🔧 Development mode: Fake auth token created with user:', fakePayload);
}

const permissionCheck=(path)=>{
    if(path=='/extlogin'){
      if(localStorage.getItem("auth_token")){
        return true
      }
      return 'extlogin'
    }
    if(localStorage.getItem("auth_token"))
    {
      try {
        let decodedToken=jwt_decode(localStorage.getItem("auth_token"))
        if(!decodedToken){
            return 'unathorised'
            }
        if(decodedToken.is_external){
            return true
            }
          if(!decodedToken.roles){
            return 'unathorised'
            }
          if(roles.includes(decodedToken.roles[0]))
              return true
      } catch (e) {
        console.error('Error decoding token:', e);
        // In development, allow access anyway
        if (process.env.NODE_ENV === 'development') {
          return true;
        }
        return 'unathorised';
      }
    }
    if(localStorage.getItem("guest") && ["/", "/dashboard", "/samples", "/samples/floormap", "/samples/addsamples", "/results/", "/results/snpresults", "/results/trackresults", "/results/viewresults", "/results/speciesresults","/results/viewresults/grid-view"].includes(path))
      return true
    else if(localStorage.getItem("guest"))
      return 'unathorised'
    
    if(window.location.href !=='/'  && !localStorage.getItem("auth_token"))
    {
        return false    
    }
    return true
}

const moblieViewCheck = () => {
  if(window.innerWidth<768 && 
    !["/dashboard", "/dashboard/", "/samples/addsamples/", "/samples/addsamples"].includes(window.location.pathname))
    return true
  else 
    return false
}

const AclRoute = ({ component: Component, path: Path, props: tour}) => {
  const permission = permissionCheck(Path)
    return (
      permission===true && Path!='/extlogin'?
      <Route exact path={Path} render={(props) =>  moblieViewCheck()? <Sample {...props} {...tour}/>: <Component {...props} {...tour}/>}/>
      :
      permission===false? <Redirect to ='/'/>
      : 
      permission=='extlogin'?
      <Route exact path={Path} render={(props) => <ExtLogin/>}/>
      :
      <Redirect to ='/unathorised'/>
    )
}

export default AclRoute


